import CommonDailyVisitorsChart from "./CommonDailyVisitorsChart";

const DailyVisitorsChart = () => {
  return (
    <CommonDailyVisitorsChart height={200} />
  );
};

export default DailyVisitorsChart;
